
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Visit Types Component
 * @param response has the backend
 * Visit Types component response
 * @param context has settings etc..
 */

export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    let result: any = {
        visittypes: [],
        error: undefined
    }

    const { log } = context;
    
    // Log the raw response for debugging
    log.debug(
        "ccw-gadget,getallvisittypes-athena",
        "getallvisittypes-athena raw response", {
        response
    });
    
    if (response && response.status >= 400) {
        result.error = response;
    } else if (response?.results && Array.isArray(response.results)) {
        result.visittypes = response.results;
    } else if (Array.isArray(response)) {
        // Handle case where response is directly an array
        result.visittypes = response;
    } else if (response?.data?.results && Array.isArray(response.data.results)) {
        // Handle case where results are nested under data
        result.visittypes = response.data.results;
    }
    
    log.debug(
        "ccw-gadget,getallvisittypes-athena",
        "getallvisittypes-athena transformation result", {
        visittypesCount: result.visittypes?.length || 0,
        hasError: !!result.error,
        result
    });
    
    return result;
}

